module.exports = __webpack_public_path__ + "img/icon_card8.3234f08b.png";